import * as BABYLON from 'babylonjs';
import VisualComponent from './VisualComponent';
import MediaManager from '@/api/MediaManager';

class URLButton extends VisualComponent {
    getType() { return "URLButton"; }

    constructor( { id } = {} ) {
        super( { id });
    }

    construct( context, prefab ) {
        const base = super.construct( context, prefab );
        
        base.getChildMeshes().forEach(mesh => {
            mesh.renderingGroupId = 3;
        });

        window.addEventListener("languageChange", () => {
            var lang = context.$store.getters.activeLanguage;
            
            // Online-Termin-Button
            if(this.prefab.id == 457401){
                if(lang.includes('en')) this.material.emissiveTexture = this.material.opacityTexture = MediaManager.getMedia(455799).getTexture(); //en
                else this.material.emissiveTexture = this.material.opacityTexture = MediaManager.getMedia(457403).getTexture(); //de

                this.material.emissiveTexture.uScale = this.material.opacityTexture.uScale = -1;
                this.material.emissiveTexture.vScale = this.material.opacityTexture.vScale = -1;
            }

            // Präsenz-Termin-Button
            if(this.prefab.id == 457392){
                if(lang.includes('en')) this.material.emissiveTexture = this.material.opacityTexture = MediaManager.getMedia(455790).getTexture(); //en
                else this.material.emissiveTexture = this.material.opacityTexture = MediaManager.getMedia(457394).getTexture(); //de

                this.material.emissiveTexture.uScale = this.material.opacityTexture.uScale = -1;
                this.material.emissiveTexture.vScale = this.material.opacityTexture.vScale = -1;
            }
        });
       
        // Disable english Buttons
        if(this.prefab.id == 455797 || this.prefab.id == 455788)
            base.setEnabled(false);

        if(prefab.getURL()) {
            var url = prefab.getURL();
            
            this.mesh.actionManager = new BABYLON.ActionManager(this.scene);
            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, () => {

                // Formular
                if(url.includes("Formular")){

                    let realURL = url.split("#")[1];

                    if(localStorage.getItem('venjakob-tectogether')){ // Alread Registered
                        if(realURL == "pdfselection"){ // Success Stories
                            window.dispatchEvent(new CustomEvent("openURL",{detail:{url: "pdfselection", title: "Venjakob Success Stories"}}));
                        
                        // Praxisvorträge
                        }else if (realURL == "Ständer"){ 
                            window.dispatchEvent(new CustomEvent("openURL",{detail:{url: context.$i18n.t("https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Vortrag Stender - Deutsch.mp4"), title: "Objekttüren nach Maß"}}));
                        }else if (realURL == "Runschke"){ 
                            window.dispatchEvent(new CustomEvent("openURL",{detail:{url: context.$i18n.t("https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Vortrag Runschke - Deutsch.mp4"), title: "Automatisierungslösung in der Fördertechnik"}}));
                        }else if (realURL == "Feldmann"){ 
                            window.dispatchEvent(new CustomEvent("openURL",{detail:{url: context.$i18n.t("https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Vortrag Feldmann - Deutsch.mp4"), title: "Individuelle Beschichtungsmethoden für Möbel im Spritzverfahren"}}));
                        }else if (realURL == "Feldmann2"){ 
                            window.dispatchEvent(new CustomEvent("openURL",{detail:{url: context.$i18n.t("https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Maschinenvorführung VEN SPRAY PERFECT - Deutsch.mp4"), title: "Excimertechnologie im Spritzverfahren"}}));
                        }   
                    }else{ // Not Registered
                        window.dispatchEvent(new CustomEvent("openURL",{detail:{url: "https://heyflow.id/venjakob-techtogether-success-story", isFormular: true, title: "Venjakob Registrierung", realURL: realURL}}));
                    }


                // E-Mail Offline
                }else if(url == "Termin-Offline"){
                    window.dispatchEvent(new CustomEvent("openURL",{detail:{url: "https://heyflow.id/techtogether_praesenz-termin#start", isFormular: true, title: "TechTogether Präsenz-Termin vereinbaren"}}));
                    // let mail = "events@venjakob.de";
                    // let subject = context.$i18n.t("Tec-Together: Präsenz-Termin vereinbaren");
                    // let body = context.$i18n.t("Liebes Venjakob Team,\r\n\r\ngerne komme ich nach Rheda-Wiedenbrück, um Neues zu sehen und ins Gespräch zu kommen.\r\n\r\nMein Wunsch-Tag: __________\r\n\r\nMein Wunsch-Zeitraum:\r\n    〇 Vormittags\r\n    〇 Nachmittags\r\n\r\nMeine Branche:\r\n    〇 Holz/Möbel\r\n    〇 Baustoffindustrie\r\n    〇 Bauelemente\r\n    〇 Glas\r\n    〇 Kunststoff\r\n    〇 Metall\r\n");
                    // window.location.href = "mailto:" + mail + "?subject=" + subject + "&body=" + encodeURIComponent(body);
                    
                // E-Mail Online
                }else if(url == "Termin-Online"){
                    window.dispatchEvent(new CustomEvent("openURL",{detail:{url: "https://heyflow.id/techtogether_online-termin", isFormular: true, title: "TechTogether Online-Termin vereinbaren"}}));
                    // let mail = "events@venjakob.de";
                    // let subject = context.$i18n.t("Tec-Together: Online-Termin vereinbaren");
                    // let body = context.$i18n.t("Liebes Venjakob Team,\r\n\r\nein Termin vor Ort ist leider nicht möglich. Gerne würde ich Sie jedoch online treffen, um Neues zu sehen und ins Gespräch zu kommen.\r\nMein Wunsch-Termin: __________\r\n\r\nMeine Branche:\r\n    〇 Holz/Möbel\r\n    〇 Baustoffindustrie\r\n    〇 Bauelemente\r\n    〇 Glas\r\n    〇 Kunststoff\r\n    〇 Metall\r\n");
                    // window.location.href = "mailto:" + mail + "?subject=" + subject + "&body=" + encodeURIComponent(body);
                
                // Betriebsführung
                }else if(url == "Betriebsführung"){
                    window.dispatchEvent(new CustomEvent("openURL",{detail:{url: context.$i18n.t("https://projects.flux-cms.de/onlineAssets/Venjakob/Venjakob - TECH TOGETHER - Betriebsführung - Deutsch.mp4") }}));
                
                // Default
                }else{
                    window.dispatchEvent(new CustomEvent("openURL",{detail:{url: url,showURL: prefab.getdisplayUrl() == "true"}}));
                }
            }));
            
            var ease = new BABYLON.CubicEase();
            ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
            
            // Highlight-ring (TODO: enable in CMS)
            // let highlight = BABYLON.MeshBuilder.CreatePlane("", { 
            //     width: this.texture.getWidth() * prefab.getScale() * this.scaleFactor, 
            //     height: this.texture.getHeight() * prefab.getScale() *this.scaleFactor,
            //     sideOrientation: BABYLON.Mesh.DOUBLESIDE 
            // }, window.scene);
            // highlight.visibility = 0;
            // highlight.material = new BABYLON.StandardMaterial("", window.scene);
            // highlight.material.opacityTexture = new BABYLON.Texture( require("@/assets/highlight.png"), window.scene);
            // highlight.material.emissiveColor = BABYLON.Color3.FromHexString(context.primaryColor);
            // highlight.material.disableLighting = true;  
            // highlight.parent = base;
            // highlight.isPickable = false;
                
            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, () => {
                BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "scaling", 60,30, this.mesh.scaling, new BABYLON.Vector3.One(), 0, ease);  
                // BABYLON.Animation.CreateAndStartAnimation("", highlight, "visibility", 30,10, highlight.visibility, 0, 0, ease);   

                window.dispatchEvent(new CustomEvent("displayName",{detail:{name: ""}}));
            }));

            this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, () => {
                BABYLON.Animation.CreateAndStartAnimation("", this.mesh, "scaling", 60,30, this.mesh.scaling, new BABYLON.Vector3.One().scale(1.05), 0, ease);
                // BABYLON.Animation.CreateAndStartAnimation("", highlight, "visibility", 30,10, highlight.visibility, 1, 0, ease);       
                
                let name = "";

                if(url.includes("pdfselection"))
                    name = "Venjakob Success Stories ansehen";
                if(url.includes("praxisvorträge"))
                    name = "Venjakob Praxisvorträge ansehen";
                if(url == "Betriebsführung")
                    name = "Venjakob Betriebsrundgang ansehen";
                if(url == "https://sales.flux-cms.de/Venjakob-Preview-Holz/?situationID=442295")
                    name = 'Virtual Showroom "Akkustikdeckenplatten" betreten';
                if(url == "https://sales.flux-cms.de/Venjakob-Preview-Holz/?situationID=442311")
                    name = 'Virtual Showroom "Fenstereinzelteilbeschichtung" betreten';
                if(url == "https://sales.flux-cms.de/Venjakob-Preview-Holz/?situationID=442291")
                    name = 'Virtual Showroom "Flexible Beschichtungen" betreten';
                if(url == "https://sales.flux-cms.de/Venjakob-Preview-Holz/?situationID=442303")
                    name = 'Virtual Showroom "Hochleistungsbeschichtung" betreten';
                if(url == "Termin-Offline")
                    name = 'Einen Präsenz-Termin per E-Mail vereinbaren';
                if(url == "Termin-Online")
                    name = 'Einen Online-Termin per E-Mail vereinbaren';

                window.dispatchEvent(new CustomEvent("displayName",{detail:{name: name}}));
            }));
        }

        return base;
    }

    enable() {
        if(this.rootNode && this.prefab.id != 455797 && this.prefab.id != 455788)
            this.rootNode.setEnabled(true);
    }
    

}

export default URLButton;
